module.exports = __webpack_public_path__ + "static/media/tergel.4628bd34.png";